export const PRE_INTAKE_NOT_STARTED = "PRE_INTAKE_NOT_STARTED";
